import { Card } from "@mui/material";
import { LensDocumentStatusNode } from "generated/graphql";
import { displayDateAndTime } from "Backend";
import CopyToClipboard from "components/CopyToClipboard";
import { useMemo } from "react";
import { useAppSelector } from "redux/hooks";
import { selectLensDocumentStatus } from "redux/slices/lensEditor";

interface DatumProps {
  title: string;
  datum: string | number;
  copy?: string;
}

function Datum({ title, datum, copy }: DatumProps) {
  return (
    <div className="flex flex-col items-baseline justify-between gap-x-4 gap-y-2">
      <dt className="text-xs text-gray-500">{title}</dt>
      <div className="flex items-center">
        <dd className="text-xl font-semibold">{datum}</dd>
        {copy && <CopyToClipboard sx={{ color: "grey.400" }} text={copy} title="Copy IDs" />}
      </div>
    </div>
  );
}

function LensDocumentStatus({ data }: { data: LensDocumentStatusNode }) {
  const versionRows = data.documentsByLensVersion;

  return (
    <Card className="mt-2 p-2">
      <div className="divide-y">
        {versionRows.map((row, idx) => {
          return (
            <dl key={idx} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 mx-auto gap-2 p-2">
              <Datum title="Lens Version" datum={row.lensVersion} />
              <Datum title="Document Count" datum={row.documentCount} />
              <Datum title="Case Count" datum={row.caseCount} copy={JSON.stringify(row.cases)} />
              <Datum title="Latest Run At" datum={displayDateAndTime(new Date(row.latestRunAt))} />
            </dl>
          );
        })}
      </div>
    </Card>
  );
}

function LensStats() {
  const data = useAppSelector(selectLensDocumentStatus);

  const timestamp = useMemo(() => new Date(), [data]);

  if (!Object.hasOwn(data, "documentsByLensVersion")) return null;

  return (
    <div className="p-4">
      <p className="text-2xl font-semibold">Lens Run Status</p>
      <div className="flex flex-col">
        <p className="text-xs text-gray-500">Last updated: {displayDateAndTime(timestamp)}</p>
        <LensDocumentStatus data={data} />
      </div>
    </div>
  );
}

export default LensStats;
